

























































import Vue from 'vue';

import store, { ObjectMarkStore } from "../services/ObjectMarkStore";
import GeneralObjectMarkTag, { GeneralObjectMarkTagDefaultProps } from '../models/GeneralObjectMarkTag';
import GeneralObjectMarkItem from '../models/GeneralObjectMarkItem';
import IconButton from '@/components/IconButton.vue';

interface Data {
  store: ObjectMarkStore;
  selectedTag: GeneralObjectMarkTag | undefined;
  tagSearchSync: string;
  selectedTags: GeneralObjectMarkItem[];
  loading: boolean;
  copying: boolean;
}

interface Methods {
  createTag(): void;
  onTagChange(selectedTag: GeneralObjectMarkTag): void;
  addTagToItem(selectedTag: GeneralObjectMarkTag): void;
  copyTagsToAllItems(withFullDelete: boolean): void;
  removeTagFromItem(selectedItem: GeneralObjectMarkItem): void;
}

interface Computed {
  availableTags: GeneralObjectMarkTag[];
}

interface Props {
  transactionId: number;
  tableRelation: string;
  disabled: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    IconButton,
  },

  props: {
    transactionId: { type: Number, required: true },
    tableRelation: { type: String, required: true },
    disabled: { type: Boolean },
  },

  async beforeMount() {
    this.loading = true;
    await store.loadObjectMarkTagsByTableRelation(this.tableRelation);
    this.selectedTags = await store.loadItemObjectMarkTags(this.tableRelation, this.transactionId);
    this.loading = false;
  },

  data() {
    return {
      store,
      tagSearchSync: "",
      selectedTag: {...GeneralObjectMarkTagDefaultProps},
      selectedTags: [],
      loading: false,
      copying: false,
    };
  },

  methods: {
    onTagChange(selectedTag) {
      this.addTagToItem(selectedTag);
    },

    async createTag() {
      const text = this.tagSearchSync?.trim();
      if (!text) return;

      if (!this.store.objectTags.some(i => i.remark.toUpperCase() == text.toUpperCase())) {
        const newTag = {...GeneralObjectMarkTagDefaultProps, tableName: this.tableRelation, remark: text}
        await this.addTagToItem(newTag);
        await store.loadObjectMarkTagsByTableRelation(this.tableRelation);
      }
    },

    async addTagToItem(selectedTag) {
      this.selectedTag = {...GeneralObjectMarkTagDefaultProps};
      if (selectedTag) {        
        await store.addObjectMarkTagToItem(this.transactionId, selectedTag);
        this.selectedTags = await store.loadItemObjectMarkTags(this.tableRelation, this.transactionId);
      }
    },

    async removeTagFromItem(selectedItem) {
      await store.removeObjectMarkTagFromItem(selectedItem)
      this.selectedTags = await store.loadItemObjectMarkTags(this.tableRelation, this.transactionId);
    },

    async copyTagsToAllItems(withFullDelete) {
      await store.copyObjectMarkTagsToAllItems(this.selectedTags[0].head, this.tableRelation, withFullDelete);
      this.copying = false;
    },
  },

  computed: {
    availableTags() {  
      return this.store.objectTags.filter(tag => !this.selectedTags.some(tag2 => tag.id == tag2.remarkId));
    },
  },
})
